import withIcon from './NewIcon';
// @ts-ignore
import IconBird from './icon/other/bird-carrying-book.svg';

export default withIcon(IconBird);
